module.exports = __webpack_public_path__ + "img/shuxian.ca177547.png";